var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.biz)?_c('v-switch',{attrs:{"color":"secondary","label":"eGift Card Program","loading":_vm.loading},on:{"change":_vm.toggle},model:{value:(_vm.biz.orderType.gc.status),callback:function ($$v) {_vm.$set(_vm.biz.orderType.gc, "status", $$v)},expression:"biz.orderType.gc.status"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }